export const letterValues: { [key: string]: { [key: string]: number } } = {
  ru: {
    '*': 0,
    а: 1,
    б: 3,
    в: 2,
    г: 3,
    д: 2,
    е: 1,
    ж: 5,
    з: 5,
    и: 1,
    й: 2,
    к: 2,
    л: 2,
    м: 2,
    н: 1,
    о: 1,
    п: 2,
    р: 2,
    с: 2,
    т: 2,
    у: 3,
    ф: 10,
    х: 5,
    ц: 10,
    ч: 5,
    ш: 10,
    щ: 10,
    ъ: 10,
    ы: 5,
    ь: 5,
    э: 10,
    ю: 10,
    я: 3,
  },
  en: {
    '*': 0,
    e: 1,
    a: 1,
    i: 1,
    o: 1,
    n: 1,
    r: 1,
    t: 1,
    l: 1,
    s: 1,
    u: 1,
    d: 2,
    g: 2,
    b: 3,
    c: 3,
    m: 3,
    p: 3,
    f: 4,
    h: 4,
    v: 4,
    w: 4,
    y: 4,
    k: 5,
    j: 8,
    x: 8,
    q: 10,
    z: 10,
  },
};
